@use '~/theme/theme' as *;
@use '~/theme/typography';

.button {
  display: inline-flex;

  @include border-radius(sm);

  align-items: center;
  cursor: pointer;
  justify-content: center;
  text-align: center;
  outline-color: transparent;
  transition:
    background-color 300ms,
    color 300ms,
    border-color 300ms,
    outline-color 300ms;

  --button-background: #{color(grey-800)};
  --button-border: #{border(grey-800)};
  --icon-color: white;
  --button-background-hovered: #{color(violet-600)};
  --button-border-hovered: #{border(violet-600)};
  --icon-color-hovered: white;
  --button-background-disabled: #{color(grey-500)};
  --button-border-disabled: #{border(grey-500)};
  --icon-color-disabled: white;

  background-color: var(--button-background);
  border: var(--button-border);
  color: var(--icon-color);

  &.confirm {
    --button-background: #{color(green-800)};
    --button-background-hovered: color-mix(in srgb, var(--button-background) 100%, #{color(grey-800)} 16%);
    --button-border: #{border(green-800)};
    --button-border-hovered: #{border(green-800)};
  }

  &.destructive {
    --button-background: #{color(lobster-800)};
    --button-background-hovered: color-mix(in srgb, var(--button-background) 100%, #{color(grey-800)} 16%);
    --button-border: #{border(lobster-800)};
    --button-border-hovered: #{border(lobster-800)};
  }

  &[data-focus-visible] {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;
  }

  &[data-hovered] {
    background: var(--button-background-hovered);
    border: var(--button-border-hovered);
    color: var(--icon-color-hovered);
  }

  &[data-disabled] {
    background-color: var(--button-background-disabled);
    border: var(--button-border-disabled);
    color: var(--icon-color-disabled);
    cursor: default;
  }

  &[data-pending] {
    cursor: default;
  }
}

.fullWidth {
  width: 100%;
}

.button.outlined {
  --button-background: transparent;
  --button-border: #{border(grey-800)};
  --icon-color: #{color(grey-800)};
  --button-border-hovered: #{border(violet-600)};
  --button-background-hovered: #{color(violet-100)};
  --icon-color-hovered: #{color(violet-600)};
  --button-background-disabled: white;
  --button-border-disabled: #{border(grey-500)};
  --icon-color-disabled: #{color(grey-500)};

  &.confirm {
    --button-background: white;
    --button-border: #{border(green-800)};
    --icon-color: #{color(green-800)};
    --button-background-hovered: #{color(green-100)};
    --button-border-hovered: #{border(green-800)};
    --icon-color-hovered: #{color(green-800)};
  }

  &.destructive {
    --button-background: white;
    --button-border: #{border(lobster-800)};
    --icon-color: #{color(lobster-800)};
    --button-background-hovered: #{color(lobster-100)};
    --button-border-hovered: #{border(lobster-700)};
    --icon-color-hovered: #{color(lobster-800)};
  }
}

.button.ghost {
  --button-background: transparent;
  --button-border: none;
  --icon-color: #{color(grey-800)};
  --button-background-hovered: #{color(violet-100)};
  --button-border-hovered: none;
  --icon-color-hovered: #{color(grey-800)};
  --button-background-disabled: transparent;
  --button-border-disabled: none;
  --icon-color-disabled: #{color(grey-500)};

  &.confirm {
    --button-background: transparent;
    --icon-color: #{color(green-800)};
    --button-background-hovered: #{color(green-100)};
    --icon-color-hovered: #{color(green-800)};
    --button-border: none;
  }

  &.destructive {
    --button-background: transparent;
    --icon-color: #{color(lobster-800)};
    --button-background-hovered: #{color(lobster-100)};
    --icon-color-hovered: #{color(lobster-800)};
    --button-border: none;
  }
}

.small {
  padding: 0 spacing(0.75);
  height: 32px;

  .icon {
    @include icon-size(sm);
  }
}

.medium {
  padding: 0 spacing(1.125);
  height: 38px;

  .icon {
    @include icon-size(sm);
  }
}

.large {
  padding: 0 spacing(1.5);
  height: 48px;

  .icon {
    @include icon-size(md);
  }
}
